// extracted by mini-css-extract-plugin
module.exports = {"outer":"_386a0","message":"_2e-_B"};